import { defineStore } from 'pinia'
import type { MyAgentAvatarSettings } from '~/composables/agent/useMyAgentAvatarSettings'

interface AvatarSettingsStoreState {
  settings: MyAgentAvatarSettings
  isReady: boolean
}

function defaultAvatarSettings(): MyAgentAvatarSettings {
  return {
    isConfigured: false,
    avatarDisplayMode: null,
    avatarConfig: null,
  }
}

export const useAvatarSettingsStore = defineStore('avatarSettings', {
  state: (): AvatarSettingsStoreState => ({
    settings: defaultAvatarSettings(),
    isReady: false,
  }),

  actions: {
    setSettings(nextSettings: MyAgentAvatarSettings): void {
      this.settings = nextSettings
    },

    setReady(ready: boolean): void {
      this.isReady = ready
    },
  },
})
